import type { ProjectItem } from '@customink/project-service-types';
import { TURN_TIMES } from '@customink/project-service-types';

/**
 * Looks through items to find the first set fulfillment type or returns standard
 * @param items
 */
export const shippingDeliveryOption = (items: ProjectItem[]) => {
  for (let i = 0; i < items.length; i++) {
    const deliveryValue = items[i].fulfillment?.priority;
    if (deliveryValue) return deliveryValue;
  }
  return TURN_TIMES.STANDARD;
};
